import { cardRecipe } from '@repo/themes/styled-system/recipes';
import { styled, type HTMLStyledProps } from '@repo/themes/styled-system/jsx';

export const Card = styled('div', cardRecipe);
export type CardProps = HTMLStyledProps<typeof Card>;
